import { smStyle } from '@/components/Adapter'
import { Flex } from '@mantine/core'
import styled from 'styled-components'

export const CoinAboutItemStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;
`

export const CoinAboutChildBoxStyled = styled(Flex)`
  max-height: calc(80vh - 100px);
  overflow-y: auto;

  padding-left: 8px;
  padding-right: 8px;
  ${smStyle} {
    max-height: 252px;
  }
`

export const CoinAboutChildItemStyled = styled(Flex)`
  cursor: pointer;

  &[data-select='true'] {
    .coin-about-item-box {
      padding: 10px 8px;
      height: 16px;
      width: 100%;
      border-radius: 6px;
      margin-top: 2px;
      margin-bottom: 2px;
      justify-content: space-between;

      &:hover {
        background-color: var(--color-neutral-2);
      }
    }

    .coin-about-item--copy {
      min-width: 16px;
    }
  }
`

export const CoinAboutCommunityItemStyled = styled(Flex)`
  align-items: center;
  &[data-select='true'] {
    padding-left: 8px;
    flex-direction: column;
    padding-right: 8px;

    .coin-about-item-box {
      padding: 8px;
      height: 20px;
      /* width: 100%; */
      width: 100%;
      border-radius: 6px;
      margin-top: 2px;
      margin-bottom: 2px;

      &:hover {
        background-color: var(--color-neutral-2);
      }
    }
    .coin-about-item--copy {
      min-width: 16px;
    }
  }
  & > button {
    width: fit-content !important;
  }
`
